import React from 'react';
import { Users, Calendar, Globe } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const StatsSection = () => {
  const { translations, language } = useLanguage();
  const stats = translations?.stats || [];

  if (!stats.length) return null;
  
  const supportText = language === 'fr' 
    ? { highlight: 'Votre', message: 'soutien fait toute la différence pour ceux qui en ont le plus besoin.' }
    : { highlight: 'Your', message: 'support makes a world of difference for those who need it most.' };

  const getIcon = (iconName) => {
    const iconProps = { className: "w-12 h-12 text-[#D4AF37]" };
    switch (iconName) {
      case 'users':
        return <Users {...iconProps} />;
      case 'calendar':
        return <Calendar {...iconProps} />;
      case 'globe':
        return <Globe {...iconProps} />;
      default:
        return <Users {...iconProps} />;
    }
  };

  return (
    <section className="bg-[#1D1D1D] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column */}
          <div>
            <h2 className="text-white text-2xl md:text-3xl font-medium leading-relaxed">
              <span className="bg-[#D4AF37] px-2 py-1">{supportText.highlight}</span> {supportText.message}
            </h2>
          </div>

          {/* Right Column - Stats */}
          <div className="space-y-8">
            {stats.map((stat, index) => (
              <div key={index} className="flex items-center gap-6">
                <div className="flex-shrink-0">
                  {getIcon(stat.icon)}
                </div>
                <div>
                  <span className="text-5xl md:text-6xl font-bold text-white">{stat.number}</span>
                  <p className="text-white/80 text-lg mt-1">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
